import { Link } from 'react-router-dom';
import { siteConfig } from '../data/siteConfig';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-surface-dark">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left - branding */}
          <div className="flex items-center gap-2.5">
            <Logo className="w-6 h-6" />
            <span className="font-medium text-slate-700 dark:text-slate-300">
              {siteConfig.name}
            </span>
          </div>

          {/* Center - links */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
            <Link to="/docs" className="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors">
              Docs
            </Link>
            <Link to="/changelog" className="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors">
              Changelog
            </Link>
            <Link to="/download" className="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors">
              Download
            </Link>
            <a href={siteConfig.discordUrl} target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors">
              Discord
            </a>
            <a href={siteConfig.kofiUrl} target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors">
              Donate
            </a>
          </div>

          {/* Right - copyright */}
          <p className="text-sm text-slate-400 dark:text-slate-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}
          </p>
        </div>
      </div>
    </footer>
  );
}
